import Cookies from 'js-cookie';
import {
  CouponCookieData,
  COUPON_COOKIE_NAME,
  COUPON_COOKIE_EXPIRATION_HOURS,
  GWA_ENTITLEMENT_COOKIE_NAME,
  GWP_ENTITLEMENT_COOKIE_NAME,
  getCookieDomain,
  DEV_MODE,
} from './util';
import { DateTime } from 'luxon';

export default function setCouponCookie(code: string, source?: string, rescueGwaProgramId?: number) {
  const data: CouponCookieData = { code, source, rescueGwaProgramId };
  Cookies.set(COUPON_COOKIE_NAME, JSON.stringify(data), {
    expires: DateTime.utc().plus({ hours: COUPON_COOKIE_EXPIRATION_HOURS }).toJSDate(),
    domain: getCookieDomain(),
    secure: !DEV_MODE,
  });
}

/** Persists the signed GWA entitlement so it's forwarded on pricing/validate/purchase. */
export function setGwaEntitlementCookie(token: string) {
  Cookies.set(GWA_ENTITLEMENT_COOKIE_NAME, token, {
    expires: DateTime.utc().plus({ hours: COUPON_COOKIE_EXPIRATION_HOURS }).toJSDate(),
    domain: getCookieDomain(),
    secure: !DEV_MODE,
  });
}

export function getGwaEntitlementCookie(): string | undefined {
  return Cookies.get(GWA_ENTITLEMENT_COOKIE_NAME);
}

/** Persists the signed GwP partner entitlement so it's forwarded on pricing/validate/purchase. */
export function setGwpEntitlementCookie(token: string) {
  Cookies.set(GWP_ENTITLEMENT_COOKIE_NAME, token, {
    expires: DateTime.utc().plus({ hours: COUPON_COOKIE_EXPIRATION_HOURS }).toJSDate(),
    domain: getCookieDomain(),
    secure: !DEV_MODE,
  });
}

export function getGwpEntitlementCookie(): string | undefined {
  return Cookies.get(GWP_ENTITLEMENT_COOKIE_NAME);
}
